import { render, staticRenderFns } from "./ExchangeFlightCard.vue?vue&type=template&id=ff28a072"
import script from "./ExchangeFlightCard.vue?vue&type=script&lang=js"
export * from "./ExchangeFlightCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports